import { render, staticRenderFns } from "./StudentInvoice.vue?vue&type=template&id=b0c90ea0&scoped=true"
import script from "./StudentInvoice.vue?vue&type=script&lang=js"
export * from "./StudentInvoice.vue?vue&type=script&lang=js"
import style0 from "./StudentInvoice.vue?vue&type=style&index=0&id=b0c90ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c90ea0",
  null
  
)

export default component.exports